module.exports = __webpack_public_path__ + "img/question-mark.9a4c8724.svg";